import React from 'react';

const HomepageDescription = () => {
  return (
    <div className="homepage-description">
      <p>
        <span>How-To </span> is a place where you can learn to do or make almost
        anything. Create an account now to make your own how-to guides or save
        your favorites.
      </p>
    </div>
  );
};

export default HomepageDescription;
